import i from"./an-object.js";import c from"./iterator-close.js";var n=i,f=c,l=function(o,t,r,a){try{return a?t(n(r)[0],r[1]):t(r)}catch(e){f(o,"throw",e)}};export{l as default};
